/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useMemo } from 'preact/hooks';
import { Item } from '../utils/UNSAFE_dataProvider';
import { ItemTextType } from '../utils/UNSAFE_selectUtils';
import { renderItemText } from '../PRIVATE_SelectCommon';

export function useDisplayValue<K, D>(
  itemText: ItemTextType<K, D>,
  valueItem?: Item<K, D>
): string {
  // create the text displayed in the field from the selected value
  const displayValue = useMemo(() => {
    return valueItem === undefined ? '' : renderItemText(valueItem, itemText) ?? '';
  }, [valueItem, itemText]);

  return displayValue;
}
